import { actionGenerator } from "utils";
import {
  VALIDATE_CODE,
  REQUEST_OTP,
  VERIFY_OTP,
  OTP_LOG,
  REQUEST_LOGIN,
  UPDATE_USER_INFO,
  REQUEST_GIGYA,
  EXCHANGE_CODE,
  TOPUP_MOBILE,
  CHECK_CAMPAIGN,
  GET_DISTRICTS,
  GET_MARTS,
  UPDATE_DELIVERY,
  GET_PROVINCES,
  CHECK_PHONE,
} from "./constants";

const actions = {
  VALIDATE_CODE: actionGenerator.genActions(VALIDATE_CODE),
  CHECK_CAMPAIGN: actionGenerator.genActions(CHECK_CAMPAIGN),
  REQUEST_OTP: actionGenerator.genActions(REQUEST_OTP),
  OTP_LOG: actionGenerator.genActions(OTP_LOG),
  VERIFY_OTP: actionGenerator.genActions(VERIFY_OTP),
  REQUEST_LOGIN: actionGenerator.genActions(REQUEST_LOGIN),
  UPDATE_USER_INFO: actionGenerator.genActions(UPDATE_USER_INFO),
  REQUEST_GIGYA: actionGenerator.genActions(REQUEST_GIGYA),
  EXCHANGE_CODE: actionGenerator.genActions(EXCHANGE_CODE),
  TOPUP_MOBILE: actionGenerator.genActions(TOPUP_MOBILE),
  GET_DISTRICTS: actionGenerator.genActions(GET_DISTRICTS),
  GET_MARTS: actionGenerator.genActions(GET_MARTS),
  UPDATE_DELIVERY: actionGenerator.genActions(UPDATE_DELIVERY),
  GET_PROVINCES: actionGenerator.genActions(GET_PROVINCES),
  CHECK_PHONE: actionGenerator.genActions(CHECK_PHONE),
};

export default actions;
